module.exports = __webpack_public_path__ + "static/media/RI-D3-8.5-051.e64b5357.webp";